import * as Sentry from '@sentry/angular';
import { provideAppInitializer, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';

export function initSentry() {
  if (!environment.sentryDsn || environment.sentryDsn === '') {
    console.warn("Sentry DSN vide, skip de l'initialisation de sentry");
    return;
  }

  Sentry.init({
    dsn: environment.sentryDsn,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: environment.envType,
    integrations: [Sentry.browserTracingIntegration()],
    release: environment.version,
    tracesSampleRate: 1.0,
  });
}

export const SentryConfig = [
  {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler(),
  },
  {
    provide: Sentry.TraceService,
    deps: [Router],
  },
  {
    provide: provideAppInitializer,
    useFactory: () => () => {},
    deps: [Sentry.TraceService],
    multi: true,
  },
];
